/**
 * StepBadge Component
 *
 * Orange numbered circle for section headers (steps 1, 2, 3).
 */

import type { IStepBadgeProps } from '@/@types/avatars';

export const StepBadge = ({ step }: IStepBadgeProps) => {
  return (
    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-accent-orange">
      <span className="text-xs font-semibold text-white">{step}</span>
    </div>
  );
};
